export const ShareAppModalVersionB = () => null
